/*
  const mySinePath = new SquareSpiralTextPath({
    fill: 'black',
    fontSize: 24,
    fontFamily: 'Arial',
    text: 'Initial Text Initial Text Initial Text Initial',
    startRadius: 10,
    endRadius: 150,
    revolutions: 2,
    segments: 1000,
    clockwise: true,
    startAngle: 0
  });

  selectNode(mySinePath);
  //console.log("mySinePath", mySinePath);
  layer.add(mySinePath);
  layer.draw(); 
*/


class SquareSpiralTextPath extends BaseTextPath {
  constructor(config) {
    super(config);

    this.className = 'SquareSpiralTextPath';  

    this.size(config?.size ?? 300);
    this.turns(config?.turns ?? 12);
    this.spacing(config?.spacing ?? 36);
    this.thickness(config?.thickness ?? 3);
  } 


  static getAttrNames() { return [  'size', 'turns', 'spacing', 'thickness']; }
  static getDefaultAttrs() { return { size: 300, turns: 12, spacing: 36, thickness: 3 }; }




  size(v) {
    if (v === undefined) return this.attrs.size ?? 0;
    this.attrs.size = v;
    this.updatePath();
    return this;
  }


  turns(v) {
    if (v === undefined) return this.attrs.turns ?? 0;
    this.attrs.turns = v;
    this.updatePath();
    return this;
  }


  spacing(v) {
    if (v === undefined) return this.attrs.spacing ?? 0;
    this.attrs.spacing = v;
    this.updatePath();
    return this;
  }


  thickness(v) {
    if (v === undefined) return this.attrs.thickness ?? 0;
    this.attrs.thickness = v;
    this.updatePath();
    return this;
  }


  updatePath() {
    this.setData(this.generateSvgPath({
        size: this.size(),
        turns: this.turns(),
        spacing: this.spacing(),
        thickness: this.thickness()
    }));
  }
 
 



  generateSvgPath({
    size = 600,
    centerX = size / 2,
    centerY = size / 2,
    turns = 40,
    spacing = 20,
    thickness = 3,
    clockwise = true,
    startAngle = 0  // 0 = right, 90 = up, 180 = left, 270 = down
    } = {}) {

    let d = `M ${centerX} ${centerY}`;
    let x = centerX;
    let y = centerY;

    // Directions: right → up → left → down
    const dirs = [[1, 0], [0, -1], [-1, 0], [0, 1]];
    if (!clockwise) dirs.reverse();

    let dirIndex = Math.round(startAngle / 90) % 4;

    // First move
    const [dx, dy] = dirs[dirIndex % 4];
    x += dx * spacing;
    y += dy * spacing;
    d += ` L ${x} ${y}`;

    let steps = 1;  // length of current pair of segments

    for (let i = 0; i < turns; i++) {
        // Turn to next direction
        dirIndex = (dirIndex + 1) % 4;
        const [dx, dy] = dirs[dirIndex];

        // Move forward
        x += dx * steps * spacing;
        y += dy * steps * spacing;
        d += ` L ${x} ${y}`;

        // Every two segments, increase the step size
        if (i % 2 === 1) steps++;
    }

    return `<path d="${d}" fill="none" stroke="black" stroke-width="${thickness}" stroke-linecap="round" stroke-linejoin="round"/>`;
  }

}
